var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab tab-cards"},[_c('div',{staticClass:"tab-card",on:{"click":function($event){return _vm.downloadJSON()}}},[_c('md-card',{staticClass:"card--park-bakcup"},[_c('md-icon',[_vm._v("cloud_download")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }